<template>
  <div>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-12 text-center" v-if="response">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="info-box">
                <span class="info-box-icon bg-yellow"
                  ><i class="ion ion-android-alert"></i
                ></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{ response }}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
          </div>
          <div class="col-md-12 text-center" v-if="success">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="info-box">
                <span class="info-box-icon bg-green"
                  ><i class="ion ion-android-checkmark-circle"></i
                ></span>
                <div class="info-box-content">
                  <span class="info-box-text">Información</span>
                  <span class="info-box-info">{{ success }}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
              <!-- /.info-box -->
            </div>
          </div>
          <div class="col-md-12 text-center" v-if="success">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <router-link
                to="/login"
                tag="button"
                v-bind:class="'btn btn-primary btn-lg'"
                >Iniciar sesión</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'CommentDetail',
      loading: '',
      response: null,
      success: null,
      email: this.$route.query.e
    }
  },
  computed: {
    datetime () {
      return new Date()
    }
  },
  methods: {
    checkPsw () {
      const parametros = new URLSearchParams(window.location.search)
      api
        .request('GET', 'api/reestablecerPsw?email=' + parametros.get('email'))
        .then((response) => {
          var data = response.data
          /* Checking if error object was returned from the server */
          /* Setting user in the state and caching record to the localStorage */
          if (data.error) {
            this.response = data.error
          }
          if (data.success) {
            this.success = data.success
          }
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    }
  },
  mounted () {
    this.checkPsw()
  },
  filters: {
    truncate: function (string, value) {
      return string.substring(0, value) + '...'
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// PswReestablecida.vue?1c3c0430